export default __webpack_public_path__ + "static/devops-80eef8047bbd321828b9ce28e50583a2.svg";